import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

import Truncate from "components/shared/Truncate";
import formatDate from "lib/date/formatDate";
import { Verb } from "types/activity";

import NotificationAvatar from "./NotificationAvatar";
import useStyles from "./styles";

type Props = {
  avatar: string;
  createdAt: string;
  isRead: boolean;
  link: string;
  name: string;
  onClick: (path: string) => void;
  text: ReactNode;
  verb: Verb;
};

export default function NotificationMenuItem({
  avatar,
  createdAt,
  isRead,
  link,
  name,
  onClick,
  text,
  verb,
}: Props) {
  const classes = useStyles();

  return (
    <Box
      className={`menu-notification-item ${classes.menuItem}`}
      onClick={() => onClick(link || "/")}
    >
      <NotificationAvatar avatar={avatar} name={name} verb={verb} />

      <Box
        className={classes.notificationText}
        display="flex"
        flexDirection="column"
      >
        <Truncate maxLines={3}>
          <Typography component="span" variant="body2">
            {text}
          </Typography>
        </Truncate>

        <Typography color="textSecondary" variant="caption">
          {formatDate(createdAt, "notification")}
        </Typography>
      </Box>

      {!isRead && <div className={classes.dot} />}
    </Box>
  );
}
